import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { TyreDiscountsDashboardQueryKeys } from "modules/TyreDiscountsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

type DeleteTyreDiscountPayload = {
  tyre_discount_id: number;
};

export const useDeleteTyreDiscountMutation = () =>
  useTypedMutation<DeleteTyreDiscountPayload, void>({
    mutationFn: (payload: DeleteTyreDiscountPayload) => ApiInstance.post("/tyre_discounts/delete", payload, ENV.dealerBaseURL),
    onSuccess: payload => {
      const discounts = typedQueryClient.getQueryData(TyreDiscountsDashboardQueryKeys.discounts);
      if (!discounts) return;

      const discountIdx = discounts.findIndex(discount => discount.id === payload.tyre_discount_id);
      if (discountIdx === -1) return;

      typedQueryClient.setQueryData(TyreDiscountsDashboardQueryKeys.discounts, discounts.toSpliced(discountIdx, 1));
    }
  });
